import logoIcon from "../assets/logo-icon.png";
import type { Page } from "../types";

export function Contact({ onNavigate }: { onNavigate: (p: Page) => void }) {
    return (
        <section id="contact" className="py-10 px-6 bg-[#1a3660]">
            <div className="max-w-3xl mx-auto text-center">
                <img src={logoIcon} alt="" className="h-16 mx-auto mb-6" />
                <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
                    Parlons de votre <span className="text-[#f07020]">projet</span>
                </h2>
                <p className="text-slate-300 text-lg max-w-xl mx-auto mb-8 leading-relaxed">
                    Que vous ayez une idée précise ou besoin de conseil, contactez-nous.
                    Premier échange gratuit et sans engagement.
                </p>
                <button
                    onClick={() => onNavigate("contact")}
                    className="inline-flex items-center gap-3 bg-[#f07020] hover:bg-[#d9621a] text-white font-semibold px-8 py-4 rounded-xl transition-colors text-lg shadow-lg shadow-black/20 cursor-pointer"
                >
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    Nous contacter
                </button>
            </div>
        </section>
    );
}
